import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[appExibeParaRota]',
    standalone: true,
})
export class ExibeParaRotaDirective implements OnDestroy {
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private router = inject(Router);

    private readonly onDestroy$: Subject<void> = new Subject<void>();

    private rotasPermitidas: string[] = [];

    constructor() {
        this.router.events
            .pipe(
                takeUntil(this.onDestroy$),
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe(() => this.atualizaView());
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    @Input()
    public set appExibeParaRota(routes: string[]) {
        this.rotasPermitidas = routes;
        this.atualizaView();
    }

    private atualizaView() {
        const rotaAtual = this.router.url;
        const deveExibir = this.rotasPermitidas.some((route) => rotaAtual.includes(route));

        if (deveExibir) {
            this.casoDevaExibir();
        } else {
            this.casoDevaEsconder();
        }
    }

    private casoDevaExibir(): void {
        if (!this.viewContainer.length) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private casoDevaEsconder(): void {
        this.viewContainer.clear();
    }
}
